
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: string) {
  // Chỉ giữ lại số
  const numericValue = value.replace(/[^\d]/g, '');
  // Format với dấu phân cách hàng nghìn
  return numericValue ? parseInt(numericValue).toLocaleString('vi-VN') : '';
}

/**
 * Generates a clean QR code string without accents and with the LHP- prefix
 * @param code The original code to format
 * @returns A formatted code suitable for QR generation
 */
export function formatQRCode(code: string): string {
  if (!code) return '';
  
  // Add LHP- prefix if not present
  const prefixedCode = code.startsWith('LHP-') ? code : `LHP-${code}`;
  
  // Remove accents and special characters
  return prefixedCode
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[đĐ]/g, 'd')
    .toUpperCase();
}

/**
 * Sanitizes an input string for use in QR codes
 * Removes accents and special characters
 */
export function sanitizeForQRCode(input: string): string {
  if (!input) return '';
  
  // Remove accents and special characters
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[đĐ]/g, 'd');
}
